import { render, staticRenderFns } from "./purchasePriceVerificationAction.vue?vue&type=template&id=39d85198&scoped=true"
import script from "./purchasePriceVerificationAction.vue?vue&type=script&lang=js"
export * from "./purchasePriceVerificationAction.vue?vue&type=script&lang=js"
import style0 from "./purchasePriceVerificationAction.vue?vue&type=style&index=0&id=39d85198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d85198",
  null
  
)

export default component.exports